module.exports = __webpack_public_path__ + "static/ranger-02-b4bacd8d8cf1e98908be3488b807b0b8.png";